import gql from 'graphql-tag';
import { getContextTMC } from '@/utils/tmc';

const query = gql`
  query minimumHotelsPrices(
    $hotelIds: [String!]!
    $checkin: String!
    $checkout: String!
    $source: String
    $corporationId: String
    $accountNumber: String
    $tripId: String
    $emailId: String
  ) {
    minimumHotelsPrices(
      hotelIds: $hotelIds
      checkin: $checkin
      checkout: $checkout
      source: $source
      tmc: "${getContextTMC()}"
      corporationId: $corporationId
      accountNumber: $accountNumber,
      tripId: $tripId
      emailId: $emailId
    ) {
      hotelMinimumRates {
        currency
        currencyName
        hotelId
        minimumRate
        badPrice
      }
    }
  }
`;

export default function minimumHotelsPrices({
  apollo,
  hotelIds,
  checkin,
  checkout,
  source,
  corporationId,
  accountNumber,
  tripId,
  emailId
}) {
  return apollo.query({
    query,
    variables: {
      hotelIds,
      checkin,
      checkout,
      source,
      corporationId,
      accountNumber,
      tripId,
      emailId
    }
  });
}
